import React from "react";
import Popover from "../Popover";
import {
  Box,
  Button,
  Center,
  Flex,
  Input,
  Spinner,
  VStack
} from "@chakra-ui/react";
import {TextG12, TextG14} from "../typography";
import {User} from "../../hooks/useAuth";
import UserAvatar from "../UserAvatar";

function UserSearchSelect({
  term,
  setTerm,
  users,
  isLoading,
  onSelect,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
}: any) {
  return (
    <Popover
      header="Search users"
      triggerElement={
        <Input
          placeholder="Search users"
          value={term}
          onChange={(e) => setTerm(e.target.value)}
        />
      }
      content={
        <Box maxH="300px" overflowY="auto">
          {isLoading ? (
            <Center py={4}>
              <Spinner />
            </Center>
          ) : users.length === 0 ? (
            <TextG14 color="gray.500">No users found</TextG14>
          ) : (
            <VStack spacing={1} align="stretch">
              {users.map((user: User) => (
                <Flex
                  key={user.id}
                  align="center"
                  gap={3}
                  p={2}
                  borderRadius="6px"
                  _hover={{ bg: 'gray.50', cursor: 'pointer' }}
                  onClick={() => onSelect(user)}
                >
                  <UserAvatar
                    user={user}
                    avatar_image={user.profilePhotoUrl}
                    w="32px"
                    h="32px"
                  />
                  <Box overflow="hidden">
                    <TextG14 fontWeight="500" noOfLines={1}>
                      {user.name}
                    </TextG14>
                    {user.handle && (
                      <TextG12 color="gray.500" noOfLines={1}>
                        @{user.handle}
                      </TextG12>
                    )}
                  </Box>
                </Flex>
              ))}

              {hasNextPage && (
                <Button size="sm" onClick={fetchNextPage}>
                  Load more
                </Button>
              )}

              {isFetchingNextPage && (
                <Center py={2}>
                  <Spinner size="sm" />
                </Center>
              )}
            </VStack>
          )}
        </Box>
      }
    />
  );
}


export default UserSearchSelect
